module.exports = __webpack_public_path__ + "static/media/geek-calculator.8bfd0562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/digitalNomad/web-development/geek-calculator.png
// module id = 173
// module chunks = 0